import store from '@/store'
import network from '@/utils/network'

/**
 * Met à jour / insère un checkpoint
 * @param customer
 * @param site
 * @param checkpoint
 * @returns {Promise<>}
 */
export const postAgencyCustomerSiteCheckpoint = async ({ customer, site, ...checkpoint }) => {
  const slugAgency = store.getters['user/agencySlug']
  const slugCustomer = _.isObject(customer) ? customer.slug : customer
  const slugSite = _.isObject(site) ? site.slug : site
  const r = await network.post(`/agency/${slugAgency}/customer/${slugCustomer}/site/${slugSite}/checkpoint`, checkpoint)
  return r.data
}
